import React, { useState, useEffect } from 'react'
import CKEditor from 'ckeditor4-react'
import { Row } from 'rsuite'
import { requiredFiled, isValidators, getMaxLengthData } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../message/errorMessage/ErrorMessage'
import CustomIconMessageInfo from '../../../widgets/CustomIconMessageInfo'
import ShowLimitLength from '../../utils/ShowLimitLength'

export default function CKEditorFrom({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  onChange = () => {},
  toolbar = [['Bold', 'Italic', 'Maximize']],
  ...props
}) {
  const keyName = props.name || schema.name
  const dfValue = props.value || schema.value
  const maxLength = props.maxLength || getMaxLengthData(schema.validators)?.value
  const isBolder = props.isBolder || schema.isBolder

  const [textLength, setTextLength] = useState(dfValue ? dfValue.length : 0)
  const [validators, setValidators] = useState(schema.validators)

  useEffect(() => {
    countText(dfValue)
  }, [dfValue])

  const onEditorChange = (evt) => {
    const data = evt.editor.getData()
    const text = evt.editor.document.getBody().getText()
    // console.log('texxxxx ', text)
    if (data.length > 0) {
      // console.log('a')
      setValue(keyName, data)
      clearErrors(keyName)
      // setTextLength(text.length)
      countText(text)
    } else {
      // console.log('b')
      setValue(keyName)
      setTextLength(0)
    }
    onChange(data)
  }

  // ## ใช้สำหรับแก้ไขเรื่องบันทึกตัวอักษรที่ติด html tag
  const countText = (str) => {
    let text
    if (str) {
      text = str.replace(/<(.|\n)*?>/g, '')
    }
    // const round0 = str?.replaceAll('&nbsp;', ' ')
    // const round1 = round0?.replaceAll('<p>', '')
    // const round2 = round1?.replaceAll('</p>', '')
    // const round3 = round2?.replaceAll('\n', '')

    setTextLength(text?.length || 0)

    if (schema?.validators?.length > 0) {
      // if (round3?.length >= maxLength && round3?.length <= maxLength) {
      if (text?.length <= maxLength) {
        const valid = [schema.validators[0]] || []
        setValidators(valid)
      } else {
        setValidators(schema.validators)
      }
    }
  }

  return (
    <>
      {schema && (
        <>
          <Row style={{ marginTop: 10 }}>
            <ErrorMessage error={errors[keyName]} />
            {schema.label && (
              <p style={{ fontWeight: isBolder ? 'bolder' : undefined }}>
                {requiredFiled(schema.validators, schema.label)}
              </p>
            )}
            {schema.description && <CustomIconMessageInfo contents={schema.description} />}
            <Controller
              key={keyName}
              name={keyName}
              control={control}
              // rules={isValidators(schema.validators)}
              rules={isValidators(validators)}
              defaultValue={dfValue}
              render={(props) => {
                // enterMode
                return (
                  <CKEditor
                    data={props.value}
                    config={{
                      versionCheck: false,
                      //autoParagraph: false, // เพิ่มขึ้นมาเพื่อลบ tag <p> ออกทำให้บันทึกตัวอักษรได้เต็มจำนวน
                      editorplaceholder: schema.label,
                      placeholder: schema.label,
                      toolbar: toolbar,
                      // contentsCss: ['body {font-size: 1rem;}'],
                      resizeEnabled: false,
                      contentsCss: [
                        'https://fonts.googleapis.com/css2?family=Sarabun:wght@300;400;600&display=swap',
                        'body { font-size: "1rem"; font-family: "Sarabun", sans-serif; }',
                      ],
                    }}
                    onChange={onEditorChange}
                  />
                )
              }}
            />
          </Row>
          <ShowLimitLength textLength={textLength} maxLength={maxLength} />
        </>
      )}
    </>
  )
}
